import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';
import { fromEnum } from '../../responseUtil';
import { OptionalAddressCodec } from '../address.types';
import { ApiAccessoryType, CollectedAccessoriesCodec } from './accessoriesApi.types';
import { ApiServiceType } from './serviceTypesApi.types';
import { ServiceVehicleCodec } from './serviceVehicleApi.types';

export enum ApiServiceOrderStatus {
    OPEN = 'open',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}

const ServiceOrderVehicleCodec = t.intersection([
    ServiceVehicleCodec,
    t.type({
        requested_accessories: t.array(fromEnum<ApiAccessoryType>('ApiServiceAccessories', ApiAccessoryType)),
    }),
    t.partial({
        collected_accessories: CollectedAccessoriesCodec,
    }),
]);

export type ApiServiceOrderVehicle = t.TypeOf<typeof ServiceOrderVehicleCodec>;

const LocationCodec = t.intersection([
    t.type({
        time_zone: t.string,
    }),
    t.partial({
        identifier: t.string,
        address: OptionalAddressCodec,
    }),
]);

export type ApiLocation = t.TypeOf<typeof LocationCodec>;

export const ServiceOrderBulkSelectionCodec = t.type({
    order_ids: t.array(NonEmptyString),
});
export type ApiServiceOrderBulkSelection = t.TypeOf<typeof ServiceOrderBulkSelectionCodec>;

const ServiceOrderCodec = t.intersection([
    t.type({
        id: NonEmptyString,
        external_order_id: NonEmptyString,
        vehicle: ServiceOrderVehicleCodec,
        status: fromEnum<ApiServiceOrderStatus>('ApiServiceOrderStatus', ApiServiceOrderStatus),
        type: fromEnum<ApiServiceType>('ApiServiceType', ApiServiceType),
        service_location: LocationCodec,
        has_unacknowledged_external_changes: t.boolean,
        is_finalized: t.boolean,
        is_archived: t.boolean,
        order_issued_at: t.string,
    }),
    t.partial({
        started_at: t.string,
        completed_at: t.string,
        general_information: t.string,
        description: t.string,
        external_option_id: NonEmptyString,
    }),
]);

export type ApiServiceOrder = t.TypeOf<typeof ServiceOrderCodec>;

export const ServiceOrderPageCodec = t.type({
    items: t.array(ServiceOrderCodec),
    has_more: t.boolean,
});

export type ApiServiceOrderPage = t.TypeOf<typeof ServiceOrderPageCodec>;
